import React from 'react';
import { useResponsive } from '@common-fe/common-fe';

import { useAuthStore } from '@/modules/user';
import { useShowLimitedAccessTopBanner } from '@/modules/user/components/LimitedAccess/hooks';
import { FEATURE_FLAGS, useFeatureFlag } from '@/utils/featureFlags';

import useReturnedItemsQuery from './queries/useReturnedItems.query';
import { useBadAddressReviewStore } from './stores/useBadAddressReview.store';
import BadAddressBanner from './BadAddressBanner';
import ReturnedChecksModal from './ReturnedChecksModal';
import ReviewAddressModal from './ReviewAddressModal';

const STORE_KEY = 'bad-address-banner';
const PROVIDER_STORE_KEY = 'bad-address-banner-provider';

const BadAddressBannerContainer: React.FC = () => {
  const { isMobile } = useResponsive();
  const auth = useAuthStore((state) => state.auth);
  const {
    hasReturnedItems,
    hasQualifyingLetters,
    isProviderOnly,
    providerChecksCount,
  } = useReturnedItemsQuery();
  const { handleOpenModal } = useBadAddressReviewStore(STORE_KEY);
  const { handleOpenModal: handleOpenProviderModal } = useBadAddressReviewStore(PROVIDER_STORE_KEY);
  const isLimitedAccessBannerVisible = useShowLimitedAccessTopBanner();
  const isReturnedChecksEnabled = useFeatureFlag(FEATURE_FLAGS.RETURNED_CHECKS);

  const showProviderBanner = isProviderOnly && isReturnedChecksEnabled;
  const showMailBanner = hasReturnedItems && !isProviderOnly;
  const showBanner = !!auth && !isLimitedAccessBannerVisible && (showProviderBanner || showMailBanner);

  return (
    <>
      {showBanner && showProviderBanner && (
        <BadAddressBanner
          isMobile={isMobile}
          variant="provider"
          checksCount={providerChecksCount}
          onReviewClick={handleOpenProviderModal}
        />
      )}
      {showProviderBanner && <ReturnedChecksModal storeKey={PROVIDER_STORE_KEY} />}
      {showBanner && showMailBanner && (
        <BadAddressBanner
          isMobile={isMobile}
          variant="mail"
          onReviewClick={handleOpenModal}
          withoutReviewButton={!hasQualifyingLetters}
        />
      )}
      {showMailBanner && hasQualifyingLetters && <ReviewAddressModal storeKey={STORE_KEY} />}
    </>
  );
};

export default BadAddressBannerContainer;
